
import Button from '@mui/material/Button';

import "./PlayNumbers"

export const PlayButton = ({play, label, onClick}) => {
  

  return (
       
    <div>
      {
       play === true ? 
      <Button
        variant="contained"
        size = "small"
        sx={{ height: '3ch', fontStyle:'italic', fontSize: '20px', color: 'black', backgroundColor: 'rgba(235, 226, 174, 1)'}}
        onClick={onClick}
        >
         {label}
      </Button>
      :
       <Button
        variant="contained"
        size = "small"
        sx={{ height: '3ch', fontStyle:'italic', fontSize: '20px', color: 'black', backgroundColor: 'white'}}
        onClick={onClick}
        >
         {label}
      </Button>

}
    </div>
     
  );
};

PlayButton.defaultProps = {
  
}
